export enum Range {
    MIN = 'min',
    MAX = 'max',
}
